// @ts-nocheck
import React from "react";
import WinRateBar from "./WinRateBar";
import {byStage} from "../data/fifaData";

// 4.3 Group stage vs. knockout (bar).

const capitalize = value => value.charAt(0).toUpperCase() + value.slice(1);

export default function GroupVsKnockout() {
  const footnote = (
    <span className="fifa-legend">
      <span className="fifa-legend__note">
        Group-stage matches (n = 441) vs. knockout matches (n = 159). Dashed line
        = 50% coin flip. Draws count as a loss.
      </span>
    </span>
  );

  return (
    <WinRateBar
      title="Group stage vs. knockout"
      takeaway="The favorite is far more reliable in knockouts (71%) than in the group stage (54%)."
      data={byStage}
      indexBy="stage"
      formatIndex={capitalize}
      axisBottomLegend="Stage"
      tooltipRows={datum => [{label: "Matches", value: datum.matches}]}
      footnote={footnote}
    />
  );
}
